import React from "react";

function Marketing() {
  return (
    <div id="marketing" className="product d-grid">
      <div className="desktop-image-container image-container">
        <img src="/assets/business/marketing.png" />
      </div>

      <div className="info-container">
        <h3 className="title mb-0 ">Marketing</h3>

        <h4 className="statement mb-0">Engage & Re-target Customers</h4>

        <p className="paragraph mb-0">
          Groome runs ads on Facebook and Google to increase customer
          appointments & products. You can also list your own offers to attract
          more clients.
        </p>

        <a href="#create-free-account" className="border-0">
          Create Free Account
        </a>
      </div>

      <div className="mobile-image-container image-container">
        <img src="/assets/business/marketing.png" />
      </div>
    </div>
  );
}

export default Marketing;
